"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("@react-mdc/base");
var constants_1 = require("./constants");
exports.CLASS_NAME = constants_1.BASE_CLASS_NAME + "__actions";
exports.propertyClassNames = {
    VERTICAL: exports.CLASS_NAME + "--vertical",
};
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.renderBaseClassName = function () {
        return exports.CLASS_NAME;
    };
    Meta.prototype.renderClassValues = function () {
        return [(_a = {},
                _a[exports.propertyClassNames.VERTICAL] = this.props.vertical,
                _a)];
        var _a;
    };
    return Meta;
}(base_1.ClassNameMetaBase));
exports.Meta = Meta;
var Actions = (function (_super) {
    __extends(Actions, _super);
    function Actions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Actions.prototype.getMetaComponent = function () {
        return Meta;
    };
    Actions.prototype.getMetaPropNames = function () {
        return [
            "className",
            "vertical",
        ];
    };
    Actions.prototype.getChildComponent = function () {
        return "section";
    };
    Actions.Meta = Meta;
    return Actions;
}(base_1.DefaultComponentBase));
exports.default = Actions;
//# sourceMappingURL=Actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/card/lib/Actions.js
// module id = ./node_modules/@react-mdc/card/lib/Actions.js
// module chunks = 1